import { AuthConfig } from "angular-oauth2-oidc";
import { Environment } from "./env.model";

// {
//     "clientid": "3f1a3116ul7nh1hvsu9vtm0f2c",
//     "issuerurl": "https://cognito-idp.eu-central-1.amazonaws.com/eu-central-1_TSZ9WDW1o"
// }

const clientID = '2b855ogkqkrfe242qmjmmqklrs';
const issuer = 'https://cognito-idp.eu-central-1.amazonaws.com/eu-central-1_nlwnxdAgX';

const authCodeFlowConfig: AuthConfig = {
  issuer,

  // tokenEndpoint: 'https://id.test.tebiauth.tebis.cloud/oauth2/token',
  // userinfoEndpoint: 'https://id.test.tebiauth.tebis.cloud/oauth2/userInfo',
  // revocationEndpoint: 'https://id.test.tebiauth.tebis.cloud/oauth2/revoke',

  strictDiscoveryDocumentValidation: false,

  // redirect after login
  redirectUri: 'https://dev.tebitask.tebis.cloud/',
  // redirect after logout
  logoutUrl: 'https://dev.tebitask.tebis.cloud/',

  clientId: clientID,

  oidc: true,
  responseType: 'code',

  scope: 'openid profile email', // offline_access for refresh token

  showDebugInformation: true,
};

export const environment: Environment = {
    name: "Development - HorizonOne GoLive",
    baseUrl: '',
    baseUrlRds: 'https://api.dev.tebitask.tebis.cloud/api',
    clientID,
    issuer,
    authCodeFlowConfig,
    // set to test auth because actual backend runs under test auth workload 
    clientIDSourceUrl: 'https://api.test.tebiauth.tebis.cloud/clientids/tebitask',
};
